/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { allScheduleControllerFind } from '../fn/all-schedule/all-schedule-controller-find';
import { AllScheduleControllerFind$Params } from '../fn/all-schedule/all-schedule-controller-find';
import { allScheduleControllerFindAllForParent } from '../fn/all-schedule/all-schedule-controller-find-all-for-parent';
import { AllScheduleControllerFindAllForParent$Params } from '../fn/all-schedule/all-schedule-controller-find-all-for-parent';
import { allScheduleControllerFindToday } from '../fn/all-schedule/all-schedule-controller-find-today';
import { AllScheduleControllerFindToday$Params } from '../fn/all-schedule/all-schedule-controller-find-today';
import { allScheduleControllerGetFilterItems } from '../fn/all-schedule/all-schedule-controller-get-filter-items';
import { AllScheduleControllerGetFilterItems$Params } from '../fn/all-schedule/all-schedule-controller-get-filter-items';
import { allScheduleControllerGetParentFilterItems } from '../fn/all-schedule/all-schedule-controller-get-parent-filter-items';
import { AllScheduleControllerGetParentFilterItems$Params } from '../fn/all-schedule/all-schedule-controller-get-parent-filter-items';
import { allScheduleControllerSearchCursor } from '../fn/all-schedule/all-schedule-controller-search-cursor';
import { AllScheduleControllerSearchCursor$Params } from '../fn/all-schedule/all-schedule-controller-search-cursor';
import { allScheduleControllerSearchCursorByParent } from '../fn/all-schedule/all-schedule-controller-search-cursor-by-parent';
import { AllScheduleControllerSearchCursorByParent$Params } from '../fn/all-schedule/all-schedule-controller-search-cursor-by-parent';
import { AllScheduleCursorPaginationDto } from '../models/all-schedule-cursor-pagination-dto';
import { AllScheduleDto } from '../models/all-schedule-dto';
import { AllScheduleOneCursorPaginationDto } from '../models/all-schedule-one-cursor-pagination-dto';
import { ScheduleFilterItemsDto } from '../models/schedule-filter-items-dto';

@Injectable({ providedIn: 'root' })
export class AllScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `allScheduleControllerFind()` */
  static readonly AllScheduleControllerFindPath = '/api/all-schedule';

  /**
   * 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFind$Response(params?: AllScheduleControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleDto>> {
    return allScheduleControllerFind(this.http, this.rootUrl, params, context);
  }

  /**
   * 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFind(params?: AllScheduleControllerFind$Params, context?: HttpContext): Observable<AllScheduleDto> {
    return this.allScheduleControllerFind$Response(params, context).pipe(
      map((r: StrictHttpResponse<AllScheduleDto>): AllScheduleDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerFindAllForParent()` */
  static readonly AllScheduleControllerFindAllForParentPath = '/api/all-schedule/parent';

  /**
   * 부모님 일정 전체 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerFindAllForParent()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFindAllForParent$Response(params?: AllScheduleControllerFindAllForParent$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleDto>> {
    return allScheduleControllerFindAllForParent(this.http, this.rootUrl, params, context);
  }

  /**
   * 부모님 일정 전체 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerFindAllForParent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFindAllForParent(params?: AllScheduleControllerFindAllForParent$Params, context?: HttpContext): Observable<AllScheduleDto> {
    return this.allScheduleControllerFindAllForParent$Response(params, context).pipe(
      map((r: StrictHttpResponse<AllScheduleDto>): AllScheduleDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerFindToday()` */
  static readonly AllScheduleControllerFindTodayPath = '/api/all-schedule/today';

  /**
   * 내 오늘 일정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerFindToday()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFindToday$Response(params?: AllScheduleControllerFindToday$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleDto>> {
    return allScheduleControllerFindToday(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 오늘 일정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerFindToday$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerFindToday(params?: AllScheduleControllerFindToday$Params, context?: HttpContext): Observable<AllScheduleDto> {
    return this.allScheduleControllerFindToday$Response(params, context).pipe(
      map((r: StrictHttpResponse<AllScheduleDto>): AllScheduleDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerSearchCursor()` */
  static readonly AllScheduleControllerSearchCursorPath = '/api/all-schedule/cursor';

  /**
   * [선생님] 일정 검색 (Cursor).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerSearchCursor$Response(params: AllScheduleControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleOneCursorPaginationDto>> {
    return allScheduleControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * [선생님] 일정 검색 (Cursor).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerSearchCursor(params: AllScheduleControllerSearchCursor$Params, context?: HttpContext): Observable<AllScheduleOneCursorPaginationDto> {
    return this.allScheduleControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<AllScheduleOneCursorPaginationDto>): AllScheduleOneCursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerSearchCursorByParent()` */
  static readonly AllScheduleControllerSearchCursorByParentPath = '/api/all-schedule/search-by-parent';

  /**
   * [부모님] 일정 검색 (Cursor).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerSearchCursorByParent()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerSearchCursorByParent$Response(params: AllScheduleControllerSearchCursorByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleCursorPaginationDto>> {
    return allScheduleControllerSearchCursorByParent(this.http, this.rootUrl, params, context);
  }

  /**
   * [부모님] 일정 검색 (Cursor).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerSearchCursorByParent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerSearchCursorByParent(params: AllScheduleControllerSearchCursorByParent$Params, context?: HttpContext): Observable<AllScheduleCursorPaginationDto> {
    return this.allScheduleControllerSearchCursorByParent$Response(params, context).pipe(
      map((r: StrictHttpResponse<AllScheduleCursorPaginationDto>): AllScheduleCursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerGetFilterItems()` */
  static readonly AllScheduleControllerGetFilterItemsPath = '/api/all-schedule/filter';

  /**
   * 일정 필터 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerGetFilterItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerGetFilterItems$Response(params?: AllScheduleControllerGetFilterItems$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleFilterItemsDto>> {
    return allScheduleControllerGetFilterItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 일정 필터 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerGetFilterItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerGetFilterItems(params?: AllScheduleControllerGetFilterItems$Params, context?: HttpContext): Observable<ScheduleFilterItemsDto> {
    return this.allScheduleControllerGetFilterItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduleFilterItemsDto>): ScheduleFilterItemsDto => r.body)
    );
  }

  /** Path part for operation `allScheduleControllerGetParentFilterItems()` */
  static readonly AllScheduleControllerGetParentFilterItemsPath = '/api/all-schedule/parent/filter';

  /**
   * 부모님 일정 필터 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allScheduleControllerGetParentFilterItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerGetParentFilterItems$Response(params?: AllScheduleControllerGetParentFilterItems$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleFilterItemsDto>> {
    return allScheduleControllerGetParentFilterItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 부모님 일정 필터 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allScheduleControllerGetParentFilterItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allScheduleControllerGetParentFilterItems(params?: AllScheduleControllerGetParentFilterItems$Params, context?: HttpContext): Observable<ScheduleFilterItemsDto> {
    return this.allScheduleControllerGetParentFilterItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<ScheduleFilterItemsDto>): ScheduleFilterItemsDto => r.body)
    );
  }

}
